import { API as AwsAPI } from "api";
import { MockApi } from "mock/mockApi";

// eslint-disable-next-line no-undef
const useMock = process.env.REACT_APP_USE_MOCK === "true";

export const API = useMock ? MockApi : AwsAPI;

// export const Auth = useMock ? MockAuth : AwsAuth;
